import { api } from 'common';

import { LlmBlockFormFields } from './FormFields';
import { llmPromptBlockDefaultConfig } from './Shared/constants';
import { llmPromptBlockDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const llmNodeConfig: BlockConfigProps<api.FlowDefinition.LlmPromptBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'llm',
  defaultConfig: llmPromptBlockDefaultConfig,
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.prompt],
      };
    },
    schema: api.FlowDefinition.LlmPromptBlockConfigSchema,
    FormFields: LlmBlockFormFields,
  },
  documentationMarkdown: llmPromptBlockDocumentationMarkdown,
  mockDataType: (config) => {
    return Array.isArray(config.responseFormat) && config.responseFormat.length > 0
      ? 'json'
      : 'string';
  },
};
